import React from "react";
import { action, observable, makeObservable, runInAction, computed } from "mobx";
import { MrbBaseViewStore } from "mrb/core";

class LoadioArtistPreviewAlbumViewStore extends MrbBaseViewStore {
    @observable isCollapsed = false;
    @observable album = null;
    panelRef = React.createRef();

    @computed get coverImageUrl() {
        if (this.album && this.album.coverImageId) {
            return this.rootStore.coverImageFactory.createLoadioAlbumCoverImageUrl(this.album.coverImageId, 150, 150);
        }

        return null;
    }

    @computed get isActiveStatusDisabled() {
        return !this.loadioArtistPreviewViewStore.item.isActive;
    }

    constructor(rootStore, { loadioArtistPreviewViewStore, album }) {
        super(rootStore);
        makeObservable(this);
        this.loadioArtistPreviewViewStore = loadioArtistPreviewViewStore;
        this.routeStore = loadioArtistPreviewViewStore.routeStore;
        this.album = album;

        this.reaction(
            () => this.isCollapsed,
            (isCollapsed) => {
                if (isCollapsed) {
                    if (this.panelRef) {
                        // We need to execute scroll function asynchronously in order to take effect.
                        setTimeout(() => {
                            this.panelRef.scrollIntoView({
                                behavior: "smooth",
                                block: "center",
                            });
                        });
                    }
                }
            }
        );

        this.reaction(
            () => this.loadioArtistPreviewViewStore.item.isActive,
            (isArtistActive) => {
                runInAction(() => {
                    this.album.isActive = isArtistActive;
                });
            }
        );
    }

    @action.bound
    onInit() {
        const albumId = this.rootStore.routerStore.routerState.queryParams.albumId;
        if (albumId && this.album.id === albumId) {
            this.isCollapsed = true;
        }
        return Promise.resolve();
    }

    @action.bound
    toggleCollapse() {
        this.isCollapsed = !this.isCollapsed;
    }
    setPanelRef = (ref) => {
        this.panelRef = ref;
    };

    @action.bound
    async toggleIsActive(value) {
        const oldValue = this.album.isActive;
        this.album.isActive = value;
        try {
            await this.routeStore.updateAlbumActiveStatus(this.album.id, this.album.isActive);
        } catch (err) {
            runInAction(() => {
                this.album.isActive = oldValue;
                this.rootStore.notificationStore.error("Unexpected error occurred. Unable to change status", err);
            });
        }
    }

    onClickAlbumTrackList = () => {
        this.rootStore.routerStore.goTo("master.administration.loadio.artist.album.tracks", {
            id: this.album.id,
        });
    };

    onDestroy() {
        //this.subPodcastAnalyticsStatsWidgetViewStore.destroy();
        super.onDestroy();
    }
}

export default LoadioArtistPreviewAlbumViewStore;
